(ns ycweb.app.website.registry.guestpurchaselist
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]))

(rum/defc guest-purchase-item < rum/reactive [app-atom item]
  (let [{:client-order-item/keys [total-price price]
         :item-line/keys [variation product qty]} item
        {:product/keys [link]} product]
    [:tr.yc-tr
     [:td.yc-td.yc-td--product-image
      (web-common/lazy-image app-atom
        (:doc/public-id (:ent/image variation))
        {:class ["yc-td__image"]}
        {:w 100 :h 100 :c "pad"})]
     [:td.yc-td.yc-td--product-text
      [:a.block-link
       {:href
        link}]
      [:div.yc-td__product-name
       (:ent/display-name product)]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table
       {:data-th "Quantity"}
       [:span.yc-td__faux-td qty]]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Price"}
       [:span.yc-td__faux-td (str "R" (yuc/currency-format price))]]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Total"}
       [:span.yc-td__faux-td (str "R" (yuc/currency-format total-price))]]]]))

(rum/defcs guest-purchase < rum/reactive (rum/local {:show-details? false} ::state) [s app-atom order]
  (let [local-atom (::state s)
        {:keys [show-details?]} (rum/react local-atom)

        {:client-order/keys [delivery-details email items]
         :item-line/keys [user]
         :registry/keys [guest-message]} order

        {:delivery/keys [contact]} delivery-details
        tel (:contact/tel contact)

        purchaser-name
        (or (:ent/display-name user) (:contact/name (:delivery/contact delivery-details)))]

    [:article.registry-buyer
     [:div.yc-gift-item
      [:h1.yc-gift-item__heading purchaser-name]
      [:small.yc-gift-item__meta email
       [:span.yc-gift-item__meta-divider "|"]
       tel]
      [:p.yc-gift-item__message guest-message]
      [:p.yc-gift-item__product
       [:b (str "Gift" (when (> (count items) 1) "s") ": ")]
       (apply str
         (interpose " ; "
           (map
             (fn [item]
               (let [{:item-line/keys [variation product]
                      :client-order-item/keys [price]} item
                     {:variation/keys [features]} variation
                     {:product/keys [simple-product-name]} product

                     purchased-item
                     (str simple-product-name
                       (when (yuc/presence features) (str ", " features))
                       (when
                         (and
                           (= simple-product-name "Digital Voucher")
                           (> price 0))
                         (str " (R" (yuc/currency-format price) ")")))]
                 purchased-item))
             items)))]]]))

(defmethod grid/action :web.myaccount.guest-purchase-list/print [_ _ _]
  #?(:cljs
     (.print js/window)))

(rum/defc registry-guest-purchase-list < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:registry/keys [client-order]} (cmn/curact process-atom [:registry])
        {:client-order/keys [registry-uuid]} client-order
        pdf-output? (= (cmn/curact process-atom [:output]) "pdf")

        guest-client-orders
        (sort-by
          (comp :contact/name :delivery/contact :client-order/delivery-details)
          (cmn/curact process-atom [:guest-client-orders]))]

    [:<>
     [:div
      {:class (yuc/bem :yc-page-content [:standard])}
      [:div.u-dont-print
       {:class (yuc/bem :yc-section [:medium])}
       [:div.u-block-center.u-max-width-480
        [:div.yc-row.group
         [:div
          {:class (yuc/bem :yc-column [:m-1-2])}
          (buttons/button-web "Print Purchase List"
            {:on-click #(grid/dispatch-action app-atom :web.myaccount.guest-purchase-list/print {})
             :style :dark
             :full true})]
         [:div
          {:class (yuc/bem :yc-column [:m-1-2])}
          (buttons/button-web "Download Purchase List"
            {:href (str "/api/registry/guest-purchase-list-download/" (str registry-uuid) ".pdf")
             :style :light
             :size :default
             :full true
             :target "_blank"})]]]]

      [:div
       {:class (yuc/bem :yc-section [:standard])}
       [:div.yc-document-logo-wrapper
        [:img
         {:alt "Yuppiechef Logo"
          :src
          (yuc/cloudinary
            (str "v1512052835/ui-resources/shared/stationery/yuppiechef-letterhead-logo.png")
            {})
          :class (yuc/bem :yc-simple-image [:full])}]]]

      (cond
        (not (empty? guest-client-orders))
        [:div
         {:class (yuc/bem :yc-section [:medium])}
         [:div.yc-gift-list
          (map
            (fn [guest-order]
              (rum/with-key
                (guest-purchase app-atom guest-order)
                (str (:ent/uuid guest-order))))
            guest-client-orders)]

         [:div.u-dont-print
          {:class (yuc/bem :yc-document-footer [:yc-gift-list])}
          [:p.u-text-center
           {:class (yuc/bem :yc-paragraph [:small])}
           "We hope you enjoy your gifts. Please give us a shout on 0861 702 4969 or drop us an email on "
           [:a.text-link {:href "mailto:hello@yuppiechef.com"} "hello@yuppiechef.com"]
           " if there is anything else we can help with."]]

         [:div.u-dont-print
          {:class (yuc/bem :yc-section [:medium])}
          [:div.u-block-center.u-max-width-480
           [:div.yc-row.group
            [:div
             {:class (yuc/bem :yc-column [:m-1-2])}
             (buttons/button-web "Print Purchase List"
               {:on-click #(grid/dispatch-action app-atom :web.myaccount.guest-purchase-list/print {})
                :style :dark
                :full true})]
            [:div
             {:class (yuc/bem :yc-column [:m-1-2])}
             (buttons/button-web "Download Purchase List"
               {:href (str "/api/registry/guest-purchase-list-download/" (str registry-uuid) ".pdf")
                :style :light
                :size :default
                :full true
                :target "_blank"})]]]]]

        :else
        [:div.u-max-width-720.u-block-center
         (feedback/feedback-raw :info
           {:title "No gifts have been purchased yet."
            :description "We'll update this list as soon as one of your guests has bought a gift for you."
            :size :small})])]
     (when-not pdf-output?
       (toaster/loading-overlay app-atom :web.registry/guestpurchaselist))]))

(defmethod grid/action :web.registry/guest-purchase-list-download [app-atom {:keys [order-id] :as opts} _]
  (comms/ajax-get :web.registry/guest-purchase-list-download
    {:uuid (:uuid opts)
     :order-id order-id}))

(defmethod flow/render-screen :web.registry/guestpurchaselist [app-atom _]
  (registry-guest-purchase-list app-atom))

(defmethod t/transition-open :web.registry/guestpurchaselist [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/guestpurchaselist)
  (swap! (cmn/process-cursor app-atom) assoc :output (:output params))
  (comms/ajax-get :web.registry/guest-purchase-list (select-keys params [:uuid])))

(defmethod comms/receive :web.registry/guest-purchase-list
  [app-atom {:keys [registry guest-client-orders]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :registry registry
    :guest-client-orders guest-client-orders)
  (toaster/close-overlay app-atom :web.registry/guestpurchaselist))
